import ReactDom from 'react-dom';
import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import '../css/VideoDialog.css';
import { useAuth } from './auth/AuthContext';

function MediaDisplayModal(props) {
    const [videoUrl, setVideoUrl] = useState('');
    const [fileName, setFileName] = useState('');
    const { secureFetch } = useAuth();

    useEffect(() => {
        if (props.isOpen) {
            onLoad();
        }
    }, [props.isOpen]);

    async function onLoad() {
        let response = await secureFetch('api/mediaplayer/video/' + props.fileId);

        // 1. Get file name from headers
        setFileName(getFileNameFromResponse(response));

        // 2. Get the binary data as a blob
        const blob = await response.blob();

        // 3. Create a local URL pointing to that blob
        const blobUrl = URL.createObjectURL(blob);

        setVideoUrl(blobUrl);
    }

    function getFileNameFromResponse(response) {
        const contentDisposition = response.headers.get('Content-Disposition');

        // 2. Parse the filename using regex or split
        let filename = "Your honor.mp4";
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
            if (filenameMatch.length > 1) {
                filename = filenameMatch[1];
            }
        }
        return filename;
    }

    // Don't forget to cleanup the memory when the component unmounts
    useEffect(() => {
        return () => {
            if (videoUrl) URL.revokeObjectURL(videoUrl);
        };
    }, [videoUrl]);

    function okClicked() {
        props.toggle();
        if (props.onOk)
            props.onOk();
    }
    function cancelClicked() {
        props.toggle();
        if (props.onCancel)
            props.onCancel();
    }

    return ReactDom.createPortal(
        <>
            <Modal size="lg" {...props} className={`video-modal ${props.loading}`} >
                <ModalHeader toggle={props.toggle}>Media Player</ModalHeader>
                <ModalBody>
                    <div>
                        {!fileName && (<p>Loading video...</p>)}
                        <h3>Streaming: {fileName}</h3>
                        <video id="myPlayer" controls width="100%" src={videoUrl} type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={okClicked}>
                        Ok
                    </Button>{' '}
                    <Button color="secondary" onClick={cancelClicked}>
                        Cancel
                    </Button>
                </ModalFooter>
                {props.loading && <div class='overlay'></div>}
            </Modal>
        </>
    , document.getElementById('portal'));

}

export default MediaDisplayModal;
